import React from 'react';
import { Grid, TextField, Autocomplete, FormControl, InputLabel, Select, MenuItem, ListSubheader, FormHelperText } from '@mui/material';
import { wardRoomOptions, procedureOptions, doctorGroups } from '../constants/options';

const PatientInformation = ({ formData, setFormData, errors, setErrors, handleChange, handleBlur }) => {
  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/;
    const { name, value } = e.target;
    if (value === '' || regex.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="UHID No"
          name="uhid_no"
          value={formData.uhid_no || ''}
          onChange={handleChange}
          required
          fullWidth
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="IP NO"
          name="ip_no"
          value={formData.ip_no || ''}
          onChange={handleChange}
          required
          InputProps={{ readOnly: true }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Autocomplete
          freeSolo
          options={wardRoomOptions}
          value={formData.ward_room_no || ''}
          onInputChange={(event, newInputValue) => {
            setFormData((prev) => ({ ...prev, ward_room_no: newInputValue }));
            if (errors.ward_room_no) {
              setErrors((prev) => ({ ...prev, ward_room_no: '' }));
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Ward/Room No."
              name="ward_room_no"
              required
              fullWidth
              error={!!errors.ward_room_no}
              helperText={errors.ward_room_no}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          freeSolo
          options={procedureOptions}
          value={formData.procedure_name || ''}
          onInputChange={(event, newValue) => {
            setFormData((prev) => ({ ...prev, procedure_name: newValue }));
            if (errors.procedure_name) {
              setErrors((prev) => ({ ...prev, procedure_name: '' }));
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Name of Procedure/Surgery"
              name="procedure_name"
              required
              fullWidth
              error={!!errors.procedure_name}
              helperText={errors.procedure_name}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth required sx={{ mt: 1 }}>
          <InputLabel id="primary-consultant-label">Primary Consultant</InputLabel>
          <Select
            labelId="primary-consultant-label"
            label="Primary Consultant"
            name="primary_consultant"
            value={formData.primary_consultant || ""}
            onChange={handleNameChange}
            onBlur={handleBlur}
            error={!!errors.primary_consultant}
          >
            <MenuItem value="">
              <em>Select Doctor</em>
            </MenuItem>
            {Object.entries(doctorGroups).map(([specialty, doctors]) => [
              <ListSubheader key={specialty}>{specialty}</ListSubheader>,
              doctors.map((doctor, idx) => (
                <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                  {doctor}
                </MenuItem>
              ))
            ])}
          </Select>
          {errors.primary_consultant && <FormHelperText>{errors.primary_consultant}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Date of Surgery"
          name="date_time_of_surgery"
          type="datetime-local"
          inputProps={{
            min: new Date().toISOString().slice(0, 16),
          }}
          value={formData.date_time_of_surgery || ''}
          onChange={handleChange}
          error={!!errors.date_time_of_surgery}
          helperText={errors.date_time_of_surgery}
          onBlur={handleBlur}
          InputLabelProps={{ shrink: true }}
          required
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default PatientInformation;
